import DatePicker from '../date-picker/DatePicker';
import { ViewMode } from '../date-picker/enum';
export default class DateTimePicker extends DatePicker {
    getWrapperClassNames() {
        const { prefixCls } = this;
        return super.getWrapperClassNames(`${prefixCls}-date-time-picker-wrapper`);
    }
    getLimitWithType(limit, _minOrMax) {
        return limit;
    }
}
DateTimePicker.displayName = 'DateTimePicker';
DateTimePicker.defaultProps = {
    ...DatePicker.defaultProps,
    mode: ViewMode.dateTime,
};
